<app-menu></app-menu>
<div class="app-container">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
